import React from 'react';

export const ContactIcon = () => (
  <svg
    width="38px"
    height="38px"
    viewBox="0 0 38 38"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg">
    <g id="UID" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="2-2-2.Contact-us-Modal"
        transform="translate(-701.000000, -235.000000)"
        fill="#FFFFFF">
        <path
          d="M737.203929,236.789128 L729.722773,235.059853 C728.631771,234.807512 727.511082,235.371568 727.065775,236.403195 L723.614647,244.455828 C723.206449,245.398395 723.481055,246.511662 724.275186,247.164779 L728.275526,250.437784 C725.75212,255.573657 721.573657,259.759542 716.430363,262.282948 L713.157357,258.282607 C712.50424,257.488477 711.390973,257.213871 710.448407,257.622069 L702.403195,261.073197 C701.371568,261.518504 700.807512,262.631771 701.059853,263.722773 L702.781706,271.196507 C703.026625,272.257822 703.96177,273 705.04535,273 C723.763083,273 739,257.844722 739,239.04535 C739,237.96177 738.257822,237.026625 737.203929,236.789128 Z M705.08988,270.62503 L703.382871,263.232936 L711.353864,259.818916 L715.769824,265.221973 C723.45879,261.614987 727.622409,257.436524 731.214551,249.777246 L725.811494,245.361286 L729.225514,237.390292 L736.617608,239.097302 C736.602765,256.50138 722.493958,270.602765 705.08988,270.62503 Z"
          id="ic-phone"></path>
      </g>
    </g>
  </svg>
);
